'use client'

import { createContext, use } from 'react'

import type { TutorialSection } from '@/lib/github/types'

export interface DocumentationLanguageContextValue {
  sections: TutorialSection[]
  selectedLanguage: string | null
  setSelectedLanguage: (lang: string) => void
  availableLanguages: string[]
  routePrefix: string
}

export const DocumentationLanguageContext = createContext<DocumentationLanguageContextValue>({
  sections: [],
  selectedLanguage: null,
  setSelectedLanguage: () => {},
  availableLanguages: [],
  routePrefix: '',
})

export function useDocumentationLanguageContext() {
  return use(DocumentationLanguageContext)
}
